module.exports = __webpack_public_path__ + "img/friend-5.24364e3d.png";